import { ref, remove, get } from "firebase/database";
import { database } from "../../../Utils/firebase";
import * as actionType from "../../../context/actions";
import GetAuthUserDataInFirebase from "./GetAgencyMemberDataInFirebase";

const DeleteAuthUserDataInFirebase = async (state, dispatch, authUserId, userId) => {
    const USERID = userId ? userId : state?.USERID;

    if (!USERID || !authUserId) return null;

    try {

        // 🔹 Path 1: remove sharedWith
        const deleteRef = ref(
            database,
            `invoiceGenerator/users/${USERID}/sharedWith/${authUserId}`
        );

        await remove(deleteRef);

        // 🔹 Path 2: remove ownerId from array-like object
        const ownerRef = ref(
            database,
            `invoiceGenerator/sharedWithUsers/${authUserId}/ownerIds`
        );

        const snapshot = await get(ownerRef);

        if (snapshot.exists()) {
            const ownerIds = snapshot.val();

            Object.keys(ownerIds).forEach(async (key) => {
                if (ownerIds[key] === USERID) {
                    const specificRef = ref(
                        database,
                        `invoiceGenerator/sharedWithUsers/${authUserId}/ownerIds/${key}`
                    );
                    await remove(specificRef);
                }
            });
        }

        // 🔹 Refresh users list
        await GetAuthUserDataInFirebase(state, dispatch, USERID);

        return {
            success: true,
            message: "User removed successfully"
        };

    } catch (error) {
        console.error("Firebase Error:", error);

        return {
            success: false,
            message: error.message || "Failed to delete user"
        };
    }
};

export default DeleteAuthUserDataInFirebase;